/**
 * OnboardingFormSection.tsx - Reusable section for form groups
 * Displays a label with form content (ChipSelector, Dropdown, etc.)
 */
import React, { ReactNode } from "react";
import { View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { spacing, colors } from "../../../../styles/design-system";

export interface OnboardingFormSectionProps {
  labelKey: string;
  children: ReactNode;
  isUppercase?: boolean;
  marginBottom?: number;
}

function OnboardingFormSection({ labelKey, children, isUppercase = false, marginBottom }: OnboardingFormSectionProps) {
  return (
    <View style={{ marginBottom: marginBottom ?? spacing.lg }}>
      <CustomText
        text={labelKey}
        size="s"
        weight="medium"
        style={{
          color: colors.grey[700],
          marginBottom: spacing.sm,
          ...(isUppercase && {
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }),
        }}
      />
      {children}
    </View>
  );
}

export default OnboardingFormSection;
